import { initState as initDimensionState } from "@reducers/selectors/dimension";
import { APP_TYPES } from "@config";
import Ground from "@scene/objects/ground";

export default {
  type: Ground.types.BASE,
  padding: {
    C1x: initDimensionState[APP_TYPES.WOOD_CONNECTION].basePlate.edgeDistance.c1x, // Null = ∞ char in UI
    C2x: initDimensionState[APP_TYPES.WOOD_CONNECTION].basePlate.edgeDistance.c2x,
    C1y: initDimensionState[APP_TYPES.WOOD_CONNECTION].basePlate.edgeDistance.c1y,
    C2y: initDimensionState[APP_TYPES.WOOD_CONNECTION].basePlate.edgeDistance.c2y
  },
  straight: {
    width: 200,
    height: 100,
    depth: 150
  },
  lShaped: {
    width: 200,
    height: 100,
    depth: 150
  },
  corner: {
    width: 200,
    height: 100,
    depth: 200
  }
};



// WEBPACK FOOTER //
// ./src/reducers/options/ground/defaults/woodConnection.js